// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-button[data-v-707ecf64]{height:2.4rem !important;align-self:flex-end}", ""]);
// Exports
module.exports = exports;
